import { readStoredUserStatus } from './user-status.store'

export const getDefaultUserRoute = (status?: string | null) => (status === 'H' || status === 'C' ? '/user/order-history' : '/user/invite')

export const resolveDefaultUserRoute = (status?: string | null) => getDefaultUserRoute(status ?? readStoredUserStatus())
